module.exports = __webpack_public_path__ + "static/media/antigua-beaches-24.81ce4455.jpg";